import {
    useEffect,
    useRef,
} from 'react';

import type { StepHookCallbacks } from './UiStepperContextProvider';
import { useUiStepper } from './UiStepperContextProvider';

export const useStepHooks = (stepHooks: StepHookCallbacks) => {
    const {
        currentStep,
        setStepHooks,
    } = useUiStepper();

    // Use ref to store the latest stepHooks to avoid dependency issues
    const stepHooksRef = useRef(stepHooks);
    stepHooksRef.current = stepHooks;

    // Create a stable key from the hook values that matter for re-registration
    const hooksKey = JSON.stringify({
        disableNext: stepHooks.disableNext,
        disableBack: stepHooks.disableBack,
        nextLabel: stepHooks.nextLabel,
        backLabel: stepHooks.backLabel,
    });
    const previousHooksKeyRef = useRef<string>('');
    const previousStepRef = useRef<number>(currentStep);

    useEffect(() => {
        // Only re-register if hooks actually changed or step changed
        if (previousHooksKeyRef.current !== hooksKey || previousStepRef.current !== currentStep) {
            setStepHooks(currentStep, stepHooksRef.current);
            previousHooksKeyRef.current = hooksKey;
            previousStepRef.current = currentStep;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ currentStep, setStepHooks, hooksKey ]);
};
